import React from 'react'
import ReactApexChart from 'react-apexcharts'

interface IProps {
  agentValue: any
  title: string
}

const AgentActivity: React.FC<IProps> = ({ agentValue, title }) => {
  console.log(agentValue)

  const parsePercentage = (value: string) => parseFloat(value.replace('%', ''))

  const getCategory = (value: number) => {
    if (value >= 90) {
      return 'Outstanding'
    } else if (value >= 80) {
      return 'Acceptable'
    } else if (value >= 50) {
      return 'Tolerable'
    } else {
      return 'Not Tolerable'
    }
  }

  const totalConversations = agentValue[0]?.totalConversations

  const resolvedConversations =
    agentValue && agentValue[0]?.totalConversationsResolved
      ? Number(agentValue[0]?.totalConversationsResolved)
      : 0
  const rejectionConversations =
    agentValue && agentValue[0]?.totalConversationsEscalated
      ? Number(agentValue[0]?.totalConversationsEscalated)
      : 0
  const resolutionRate =
    totalConversations !== 0 ? (resolvedConversations / totalConversations) * 100 : 0
  const escalationRate =
    totalConversations !== 0 ? (rejectionConversations / totalConversations) * 100 : 0
  const responseData = agentValue[0]?.avgResolutionTimeMins
  const time = responseData
  console.log(time)
  const responseRate = Number(time)

  let percentage

  if (responseRate <= 15) {
    percentage = 100
  } else if (responseRate === 16) {
    percentage = 90
  } else if (responseRate === 17) {
    percentage = 80
  } else if (responseRate === 18) {
    percentage = 70
  } else if (responseRate > 19) {
    percentage = 60
  } //
  console.log(responseRate)

  const barChartOptions: any = {
    chart: {
      type: 'bar',
      height: 100,
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => `${val}% (${getCategory(val)})`
    },
    xaxis: {
      categories: ['Resolution Rate', 'Escalation Rate']
    },
    colors: [
      ({ value }: { value: number }) => {
        if (value >= 90) {
          return '#00E396' // Outstanding
        } else if (value >= 80) {
          return '#FEB019' // Acceptable
        } else if (value >= 50) {
          return '#775DD0' // Tolerable
        } else {
          return '#FF4560' // Not Tolerable
        }
      }
    ]
  }

  const series = [
    {
      name: 'Performance',
      data: [
        parsePercentage(String(resolutionRate.toFixed(1))),
        parsePercentage(String(escalationRate.toFixed(1)))
      ]
    }
  ]

  return (
    <>
      <div className='card card-xl-stretch mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>{title}</span>
          </h3>
        </div>

        {/* <!--begin::Card body--> */}
        <div className='card-body'>
          <ReactApexChart options={barChartOptions} series={series} type='bar' height={'300px'} />
          <div
            className='legend'
            style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '16px' }}
          ></div>
        </div>
      </div>
    </>
  )
}

export default AgentActivity
